import { render, staticRenderFns } from "./CalendarWeekdays.vue?vue&type=template&id=479f272a&scoped=true"
import script from "./CalendarWeekdays.vue?vue&type=script&lang=js"
export * from "./CalendarWeekdays.vue?vue&type=script&lang=js"
import style0 from "./CalendarWeekdays.vue?vue&type=style&index=0&id=479f272a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f272a",
  null
  
)

export default component.exports